<template>
	<div class="content">
		<div class="content-heading fw-semibold">MEMBER INFORMATION</div>
		<div v-if="memberInfo.info_complete==0 && memberInfo.risk_investor_type==null">
			<div class="block block-rounded">
				<div class="block-content block-content-full">
					<div class="form-floating mb-3">
						<input v-model="form.suffix" type="text" id="suffix" name="suffix" class="form-control"/>
						<label class="form-label" for="suffix">Suffix<span class="text-danger">*</span></label>
						<div v-if="form.errors.suffix" class="show-error">
							<i class="fa fa-exclamation-circle"></i>
							{{ form.errors.suffix }}
						</div>
					</div>
					<div class="form-floating mb-3">
						<input v-model="form.fname" type="text" id="fname" name="fname" class="form-control"/>
						<label class="form-label" for="fname">First Name<span class="text-danger">*</span></label>
						<div v-if="form.errors.fname" class="show-error">
							<i class="fa fa-exclamation-circle"></i>
							{{ form.errors.fname }}
						</div>
					</div>
					<div class="form-floating mb-3">
						<input v-model="form.mname" type="text" id="mname" name="mname" class="form-control"/>
						<label class="form-label" for="mname">Middle Name<span class="text-danger">*</span></label>
						<div v-if="form.errors.mname" class="show-error">
							<i class="fa fa-exclamation-circle"></i>
							{{ form.errors.mname }}
						</div>
					</div>
					<div class="form-floating mb-3">
						<input v-model="form.lname" type="text" id="lname" name="lname" class="form-control"/>
						<label class="form-label" for="lname">Last Name<span class="text-danger">*</span></label>
						<div v-if="form.errors.lname" class="show-error">
							<i class="fa fa-exclamation-circle"></i>
							{{ form.errors.lname }}
						</div>
					</div>
					<div class="form-floating mb-3">
						<div class="form-control text-muted">{{form.username}}</div>
						<label class="form-label" for="email">Email Address<span class="text-danger">*</span></label>
					</div>
					<div class="form-floating mb-3">
						<!-- <input v-model="form.mobile" type="text" id="mobile" name="mobile" class="form-control"/> -->
						<vue-tel-input
							@input="onInput"
							@countryChanged="onCountryChange"
							v-model="form.mobile"
							:value="form.mobile"
							class="form-control"
							:class="{ 'is-invalid': form.errors.mobile }"
							:input-options="{
								placeholder: 'Enter mobile number',
							}"
							:defaultCountry="form.country_code"
							mode="international"
						/>
						<label class="form-label" for="mobile">Mobile#<span class="text-danger">*</span></label>
						<div v-if="(is_valid_mobile==false || is_valid_mobile==undefined) && form.errors.mobile" class="show-error">
							<i class="fa fa-exclamation-circle"></i>
							{{ form.errors.mobile }}
						</div>
					</div>
					<div class="form-floating mb-3">
						<input v-model="form.bday" type="text" id="bday" name="bday" class="form-control"/>
						<label class="form-label" for="bday">Date of Birth<span class="text-danger">*</span></label>
						<div v-if="form.errors.bday" class="show-error">
							<i class="fa fa-exclamation-circle"></i>
							{{ form.errors.bday }}
						</div>
					</div>
					<div class="form-floating mb-3">
						<select v-model="form.gender" id="gender" name="gender" class="form-select">
							<option value="Male">Male</option>
							<option value="Female">Female</option>
						</select>
						<label class="form-label" for="gender">Gender<span class="text-danger">*</span></label>
						<div v-if="form.errors.gender" class="show-error">
							<i class="fa fa-exclamation-circle"></i>
							{{ form.errors.gender }}
						</div>
					</div>
					<div class="form-floating mb-3">
						<select v-model="form.civil_status" name="civil_status" class="form-select">
							<option value="Single">Single</option>
							<option value="Married">Married</option>
							<option value="Widowed">Widowed</option>
							<option value="Separated">Legally Separated</option>
						</select>
						<label class="form-label" for="civil_status">Civil Status</label>
					</div>
					<div class="form-floating mb-3">
						<input v-model="form.city_of_birth" type="text" name="city_of_birth" class="form-control"/>
						<label class="form-label" for="city_of_birth">City of Birth</label>
					</div>
					<div class="form-floating mb-3">
						<input v-model="form.country_of_birth" type="text" name="country_of_birth" class="form-control"/>
						<label class="form-label" for="country_of_birth">Country of Birth</label>
					</div>
					<div class="form-floating mb-3">
						<select v-model="form.nationality" name="nationality" class="form-select">
							<option value="Filipino">Filipino</option>
							<option value="Others">Others</option>
						</select>
						<label class="form-label" for="nationality">Nationality</label>
					</div>
				</div>
			</div>
			<div class="block block-rounded">
				<div class="block-content block-content-full">
					<p class="h5">Current Address {{form.country}}</p>
					<div class="form-floating mb-3">
						<select v-model="form.country" id="country" name="country" class="form-select">
							<option v-for="country in countries" :value="country.country">{{country.country}}</option>
						</select>
						<label class="form-label" for="country">Country<span class="text-danger">*</span></label>
						<div v-if="form.errors.country" class="show-error">
							<i class="fa fa-exclamation-circle"></i>
							{{ form.errors.country }}
						</div>
					</div>
					<div v-if="form.country=='Philippines'">
						<div class="form-floating mb-3">
							<select v-model="form.province" id="province" name="province" class="form-select">
								<option v-for="province in provinces" :value="province.prov_code+'|'+province.prov_desc">{{province.prov_desc}}</option>
							</select>
							<label class="form-label" for="province">Province<span class="text-danger">*</span></label>
							<div v-if="form.errors.province" class="show-error">
								<i class="fa fa-exclamation-circle"></i>
								{{ form.errors.province }}
							</div>
						</div>
						<div class="form-floating mb-3">
							<select v-model="form.city" id="city" name="city" class="form-select">
								<option v-for="city in cities[(form.province).split('|')[0] || 0]" :value="city.citymun_desc">{{city.citymun_desc}}</option>
							</select>
							<label class="form-label" for="city">City<span class="text-danger">*</span></label>
							<div v-if="form.errors.city" class="show-error">
								<i class="fa fa-exclamation-circle"></i>
								{{ form.errors.city }}
							</div>
						</div>
					</div>
					<div class="form-floating mb-3">
						<input v-model="form.address" type="text" id="address" name="address" class="form-control"/>
						<label class="form-label" for="address">Unit, Subdivision, Street, Barangay or residence<span class="text-danger">*</span></label>
						<div v-if="form.errors.address" class="show-error">
							<i class="fa fa-exclamation-circle"></i>
							{{ form.errors.address }}
						</div>
					</div>
					<div v-if="form.country=='Philippines'" class="form-floating mb-3">
						<input v-model="form.zipcode" type="text" id="zipcode" name="zipcode" class="form-control"/>
						<label class="form-label" for="zipcode">ZIP Code</label>
					</div>
				</div>
			</div>
			<div class="block block-rounded">
				<div class="block-content block-content-full">
					<div class="form-floating mb-3">
						<select v-model="form.primary_income_source" name="city" class="form-select">
							<option value="Salary">Salary</option>
							<option value="Saving/Investments">Saving/Investments</option>
							<option value="Variable Income">Variable Income</option>
							<option value="Pension">Pension</option>
							<option value="Inheritance">Inheritance</option>
							<option value="Allowance/Remittance">Allowance/Remittance</option>
						</select>
						<label class="form-label" for="city">Pimary Income Source</label>
					</div>
					<div class="form-floating mb-3">
						<select v-model="form.primary_occupation" name="city" class="form-select">
							<option value="Private Employee">Private Employee</option>
							<option value="Government Employee">Government Employee</option>
							<option value="Self-Employed/Freelance">Self-Employed/Freelance</option>
							<option value="Business Owner">Business Owner</option>
							<option value="Overseas Filipino/Migrant Worker">Overseas Filipino/Migrant Worker</option>
							<option value="Student">Student</option>
							<option value="Unemployed">Unemployed</option>
							<option value="Retiree">Retiree</option>
						</select>
						<label class="form-label" for="city">Pimary Occupation</label>
					</div>
					<div class="border p-3 mb-3">
						<p class="h5">Identification Documents</p>
						<p class="text-danger">
							Note: Please upload 3 photos. One front, one back and selfie with the valid ID. Keep your signature visible.
						</p>
						<p>
							In order to comply with the Anti-Money Laundering Act (AMLA), Rampver Online requires all its clients to complete a verification process. Kindly upload the frontside and backside of any valid primary Philippine government-issued IDs. (Ex. Driver's License, Passport, National ID, Voter's ID, Postal ID, UMID). If you don't have any of the above, the following are also accepted: Philhealth ID, SSS ID , TIN ID, PRC ID, and School ID (for students only).
						</p>
						<div class="form-floating mb-3">
							<select v-model="form.id_type" name="id_type" class="form-select">
								<option value="">Select Valid ID</option>
								<option value="Drivers License">Drivers License</option>
								<option value="Passport">Passport</option>
								<option value="Natonal ID">Natonal ID</option>
								<option value="Voters ID">Voters ID</option>
								<option value="Postal ID">Postal ID</option>
								<option value="UMID">UMID</option>
								<option value="Philhealth ID">Philhealth ID</option>
								<option value="TIN ID">TIN ID</option>
								<option value="SSS/GSIS">SSS/GSIS</option>
								<option value="PRC ID">PRC ID</option>
								<option value="School ID">School ID (for students only)</option>
								<option value="NONE">I don't have any of the above</option>
							</select>
							<label class="form-label" for="id_type">Presented Valid ID Type</label>
						</div>
						<div v-if="!['',null,'NONE'].includes(form.id_type)" class="form-floating mb-3">
							<input v-model="form.id_type_number" type="text" name="id_type_number" class="form-control"/>
							<label class="form-label" for="id_type_number">ID Number</label>
							<div v-if="form.errors.id_type_number" class="show-error">
								<i class="fa fa-exclamation-circle"></i>
								{{ form.errors.id_type_number }}
							</div>
						</div>
						<div class="row">
							<div class="col-md-4 mb-2">
								<div v-if="form.errors.id_type_uploaded" class="show-error">
									<i class="fa fa-exclamation-circle"></i>
									{{ form.errors.id_type_uploaded }}
								</div>
								<div class="p-3 file-upload-content text-center overflow-hidden ribbon">
									<div v-if="form.id_type_uploaded==null" id="id_type_uploaded_content">
										<p class="fw-bold">Front side of the ID<span class="text-danger">*</span></p>
										<input type="file" accept="image/png,image/jpg,image/jpeg" id="id_type_uploaded" name="id_type_uploaded" class="file-upload"/>
										<div class="form-block">
											<p>Drag and drop a file here or click</p>
											<div @click="uploadFile('info','id_type_uploaded')" class="btn btn-outline-info">Upload File</div>
										</div>
									</div>
									<div class="preview_content">
										<button v-if="form.id_type_uploaded!=null" @click="removeUpload('info','id_type_uploaded')" type="button" title="Remove the file" class="me-3 ribbon-box ribbon-right btn btn-sm btn-alt-danger"><i class="fa fa-trash"></i></button>
										<div id="id_type_uploaded_preview">
											
										</div>
									</div>
								</div>
							</div>
							<div class="col-md-4 mb-2">
								<div v-if="form.errors.id_type_back_uploaded" class="show-error">
									<i class="fa fa-exclamation-circle"></i>
									{{ form.errors.id_type_back_uploaded }}
								</div>
								<div class="p-3 file-upload-content text-center overflow-hidden ribbon">
									<div v-if="form.id_type_back_uploaded==null" id="id_type_back_uploaded_content">
										<p class="fw-bold">Back side of the ID<span class="text-danger">*</span></p>
										<input type="file" accept="image/png,image/jpg,image/jpeg" id="id_type_back_uploaded" name="id_type_back_uploaded" class="file-upload"/>
										<div class="form-block">
											<p>Drag and drop a file here or click</p>
											<div @click="uploadFile('info','id_type_back_uploaded')" class="btn btn-outline-info">Upload File</div>
										</div>
									</div>
									<div class="preview_content">
										<button v-if="form.id_type_back_uploaded!=null" @click="removeUpload('info','id_type_back_uploaded')" type="button" title="Remove the file" class="me-3 ribbon-box ribbon-right btn btn-sm btn-alt-danger"><i class="fa fa-trash"></i></button>
										<div id="id_type_back_uploaded_preview">
											
										</div>
									</div>
								</div>
							</div>
							<div class="col-md-4 mb-2">
								<div v-if="form.errors.id_type_selfie_uploaded" class="show-error">
									<i class="fa fa-exclamation-circle"></i>
									{{ form.errors.id_type_selfie_uploaded }}
								</div>
								<div class="p-3 file-upload-content text-center overflow-hidden ribbon">
									<div v-if="form.id_type_selfie_uploaded==null" id="id_type_selfie_uploaded_content">
										<p class="fw-bold">Selfie with the ID<span class="text-danger">*</span></p>
										<input type="file" accept="image/png,image/jpg,image/jpeg" id="id_type_selfie_uploaded" name="id_type_selfie_uploaded" class="file-upload"/>
										<div class="form-block">
											<p>Drag and drop a file here or click</p>
											<div @click="uploadFile('info','id_type_selfie_uploaded')" class="btn btn-outline-info">Upload File</div>
										</div>
									</div>
									<div class="preview_content">
										<button v-if="form.id_type_selfie_uploaded!=null" @click="removeUpload('info','id_type_selfie_uploaded')" type="button" title="Remove the file" class="me-3 ribbon-box ribbon-right btn btn-sm btn-alt-danger"><i class="fa fa-trash"></i></button>
										<div id="id_type_selfie_uploaded_preview">
											
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="my-3 text-end">
				<button @click="submitForm()" type="button" class="btn btn-success" :disabled="form.processing">
					<i v-if="!form.processing" class="fa fa-arrow-right me-1"></i>
					<div v-else class="spinner-border spinner-border-sm text-white me-1" role="status" >
						<span class="sr-only mr-1">Loading...</span>
					</div>
					Next Process
				</button>	
			</div>	
		</div>
		<div v-if="memberInfo.is_docu_rejected==1">
			<div class="block block-rounded">
				<div class="block-content block-content-full">
					<p class="text-danger text-center h4">Documents was rejected</p>
					<p class="text-danger text-center">{{memberInfo.docu_remarks}}</p>
					<div class="row">
						<div class="col-md-4 mb-2">
							<div class="error-content">
								<div v-if="formDocu.errors.id_type_uploaded" class="show-error">
									<i class="fa fa-exclamation-circle"></i>
									{{ formDocu.errors.id_type_uploaded }}
								</div>
							</div>
							<div class="p-3 file-upload-content text-center overflow-hidden ribbon">
								<div v-if="formDocu.id_type_uploaded==null" id="id_type_uploaded_content">
									<p class="fw-bold">Front side of the ID<span class="text-danger">*</span></p>
									<input type="file" accept="image/png,image/jpg,image/jpeg" id="id_type_uploaded" name="id_type_uploaded" class="file-upload"/>
									<div class="form-block">
										<p>Drag and drop a file here or click</p>
										<div @click="uploadFile('docu','id_type_uploaded')" class="btn btn-outline-info">Upload File</div>
									</div>
								</div>
								<div class="preview_content">
									<button v-if="formDocu.id_type_uploaded!=null" @click="removeUpload('docu','id_type_uploaded')" type="button" title="Remove the file" class="me-3 ribbon-box ribbon-right btn btn-sm btn-alt-danger"><i class="fa fa-trash"></i></button>
									<div id="id_type_uploaded_preview">
										
									</div>
								</div>
							</div>
						</div>
						<div class="col-md-4 mb-2">
							<div class="error-content">
								<div v-if="formDocu.errors.id_type_back_uploaded" class="show-error">
									<i class="fa fa-exclamation-circle"></i>
									{{ formDocu.errors.id_type_back_uploaded }}
								</div>
							</div>
							<div class="p-3 file-upload-content text-center overflow-hidden ribbon">
								<div v-if="formDocu.id_type_back_uploaded==null" id="id_type_back_uploaded_content">
									<p class="fw-bold">Back side of the ID<span class="text-danger">*</span></p>
									<input type="file" accept="image/png,image/jpg,image/jpeg" id="id_type_back_uploaded" name="id_type_back_uploaded" class="file-upload"/>
									<div class="form-block">
										<p>Drag and drop a file here or click</p>
										<div @click="uploadFile('docu','id_type_back_uploaded')" class="btn btn-outline-info">Upload File</div>
									</div>
								</div>
								<div class="preview_content">
									<button v-if="formDocu.id_type_back_uploaded!=null" @click="removeUpload('docu','id_type_back_uploaded')" type="button" title="Remove the file" class="me-3 ribbon-box ribbon-right btn btn-sm btn-alt-danger"><i class="fa fa-trash"></i></button>
									<div id="id_type_back_uploaded_preview">
										
									</div>
								</div>
							</div>
						</div>
						<div class="col-md-4 mb-2">
							<div class="error-content">
								<div v-if="formDocu.errors.id_type_selfie_uploaded" class="show-error">
									<i class="fa fa-exclamation-circle"></i>
									{{ formDocu.errors.id_type_selfie_uploaded }}
								</div>
							</div>
							<div class="p-3 file-upload-content text-center overflow-hidden ribbon">
								<div v-if="formDocu.id_type_selfie_uploaded==null" id="id_type_selfie_uploaded_content">
									<p class="fw-bold">Selfie with the ID<span class="text-danger">*</span></p>
									<input type="file" accept="image/png,image/jpg,image/jpeg" id="id_type_selfie_uploaded" name="id_type_selfie_uploaded" class="file-upload"/>
									<div class="form-block">
										<p>Drag and drop a file here or click</p>
										<div @click="uploadFile('docu','id_type_selfie_uploaded')" class="btn btn-outline-info">Upload File</div>
									</div>
								</div>
								<div class="preview_content">
									<button v-if="formDocu.id_type_selfie_uploaded!=null" @click="removeUpload('docu','id_type_selfie_uploaded')" type="button" title="Remove the file" class="me-3 ribbon-box ribbon-right btn btn-sm btn-alt-danger"><i class="fa fa-trash"></i></button>
									<div id="id_type_selfie_uploaded_preview">
										
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="my-3 text-end">
						<button @click="submitDocuments()" type="button" class="btn btn-success" :disabled="formDocu.processing">
							<i v-if="!formDocu.processing" class="fa fa-upload me-1"></i>
							<div v-else class="spinner-border spinner-border-sm text-white me-1" role="status" >
								<span class="sr-only mr-1">Loading...</span>
							</div>
							Re-Upload Documents
						</button>	
					</div>
				</div>
			</div>
		</div>
		<div v-if="memberInfo.is_docu_rejected==0 && memberInfo.is_verified==0 && memberInfo.info_complete==1 && memberInfo.risk_investor_type!=null">
			<div class="block block-rounded">
				<div class="block-content block-content-full text-center">
					<p class="content-heading text-start">Application Status</p>
					<p class="fw-bold">Please wait!</p>
					<p class="fw-semibold fs-sm text-danger">Note: Member Information approval takes 2-3 business days.</p>
					<p>
						We are verifying your member information. Once it's approved, we will proceed to the investment process.
					</p>
				</div>
			</div>
		</div>
		<div v-if="memberInfo.is_verified==1">
			<div class="block block-rounded">
				<div class="block-content block-content-full">
					<p class="content-heading">Application Status</p>
					<p class="fw-bold text-center h4">Congratulation!</p>
					<p class="text-center">
						We are glady to information you, that we already processing your investment to <strong>{{memberInfo.investment}}</strong>.
					</p>
				</div>
			</div>
		</div>
	</div>
</template>
<script>

	window.dataLayer = window.dataLayer || [];
	function gtag(){dataLayer.push(arguments);}
	gtag('js', new Date());

	gtag('config', window.gtag_id);

	import { useForm } from '@inertiajs/inertia-vue3';
	import { onMounted, watch, ref, reactive } from 'vue';
	import AuthLayout from '../../../Layouts/AuthLayout';
	import { Inertia } from '@inertiajs/inertia';

	export default{
		layout: AuthLayout,
		props:{
			memberInfo 	: Object,
			flash 		: Object,
			errors 		: Object,
			countries 	: Object,
			provinces 	: Object,
			cities 		: Object,
		},
		mounted(){

		},
		setup(props,context){

			const is_valid_mobile 	= ref(false);

			const form = useForm({
				member_uuid 				: props.memberInfo.member_uuid,
				invest_uuid 				: props.memberInfo.invest_uuid,
				username 					: props.memberInfo.username,
				suffix 						: props.memberInfo.suffix,
				fname 						: props.memberInfo.fname,
				mname 						: props.memberInfo.mname,
				lname 						: props.memberInfo.lname,
				country_code 				: props.memberInfo.country_code,
				country_calling_code 		: props.memberInfo.country_calling_code,
				mobile 						: props.memberInfo.mobile,
				bday 						: props.memberInfo.bday,
				gender 						: props.memberInfo.gender,
				civil_status 				: props.memberInfo.civil_status,
				city_of_birth 				: props.memberInfo.city_of_birth,
				country_of_birth 			: props.memberInfo.country_of_birth,
				nationality 				: props.memberInfo.nationality,
				country 					: props.memberInfo.country,
				province 					: props.memberInfo.province??'',
				city 						: props.memberInfo.city,
				address 					: props.memberInfo.address,
				zipcode 					: props.memberInfo.zipcode,
				primary_income_source 		: props.memberInfo.primary_income_source,
				primary_occupation 			: props.memberInfo.primary_occupation,
				id_type 					: props.memberInfo.id_type,
				id_type_number 				: props.memberInfo.id_type_number,
				id_type_uploaded 			: null,
				id_type_back_uploaded 		: null,
				id_type_selfie_uploaded 	: null
			});

			const formDocu = useForm({
				member_uuid					: props.memberInfo.member_uuid,
				invest_uuid					: props.memberInfo.invest_uuid,
				id_type_uploaded 			: null,
				id_type_back_uploaded 		: null,
				id_type_selfie_uploaded 	: null,
			});

			const onInput = (number, phoneObject) => {
				if (phoneObject?.formatted) {
					form.mobile 				= phoneObject.number;
					form.country_calling_code 	= phoneObject.countryCallingCode;
				}
				is_valid_mobile.value = phoneObject.valid;
			}

			const onCountryChange = (countryObject) => {
				form.country_code = countryObject.iso2
			}

			const uploadFile = (_loc,file_name)=>{
				let _this = $("#"+file_name);

				_this.click();

				_this.change(function(e){
					let file = e.target.files[0] || e.dataTransfer.files[0];

					let image_preview = document.getElementById(file_name+"_preview");

					if(_loc=='info')
					{
						form[`${file_name}`] 		= null;
					}else
					{
						formDocu[`${file_name}`] 	= null;
					}
					

					image_preview.innerHTML = '';

					if (file!=null)
					{

						if(_loc=='info')
						{
							form[`${file_name}`] 		= file;
						}else
						{
							formDocu[`${file_name}`] 	= file;
						}
						
						let src 				= URL.createObjectURL(file);
						image_preview.innerHTML = `<img src="${src}" class="img-fluid" style="height:100%;width:auto" />`;
					}
				});
				

			}

			const removeUpload = (_loc,file_name)=>{
				let image_preview 			= document.getElementById(file_name+"_preview");

				if(_loc=='info')
				{
					form[`${file_name}`] 		= null;
				}else
				{
					formDocu[`${file_name}`] 		= null;
				}
				
				image_preview.innerHTML 	= '';
			}

			const submitForm = ()=>{

				form.post(route('member.investment.post.info'),{
					forceFormData: true,
					preserveState: true,
					preserveScroll: true,
					only:['errors','flash'],
					onSuccess: (res)=>{

						if(props.flash.toast.type=='success')
						{
							Inertia.get(route('member.investment.risk'));
						}

					},
					onError:()=>{
					var fields = ['suffix','fname','mname','lname','gender','bday','mobile','address','country','province','city','id_type_number','id_type_uploaded','id_type_back_uploaded','id_type_selfie_uploaded'];
					//Check if error exist and focus the first field.
					for (var i = 0; i < fields.length; i++) {

						var found = false;

						for (const [key, value] of Object.entries(form)) {

							if(fields[i]==key){

								if(form.errors[key]){
									var  el = document.getElementById(key);
									if(key=='mobile'){
										el = document.getElementsByClassName("vti__input")[0];
									}
									
									el.focus();	

									found = true;

									break;
								}
							}
						}

						if(found==true){
							// toggleModal();
							break;
						}
					}
				}
				})
			}

			const submitDocuments = ()=>{

				formDocu.post(route('member.investment.post.documents'),{
					forceFormData: true,
					preserveState: true,
					preserveScroll: true,
					only:['errors','flash','memberInfo'],
				});
			}

			return{
				form,
				formDocu,
				onInput,
				onCountryChange,
				is_valid_mobile,
				uploadFile,
				removeUpload,
				submitForm,
				submitDocuments,
			}
		}
	}
</script>

<style>
	.file-upload{
		display: none;
	}
	.file-upload-content{
		border:1px solid #dadada;
		height:202px;
		align-items: center;
	}

	.file-upload-content:hover{
		border:1px solid #718f96;
		box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15) !important;
	}
	.error-content{
		padding-top:1px;
		height:53px;
	}
</style>